// Global namespace
import * as THREE from 'three-declare';

// reassign
THREE.FileLoader.prototype._load = THREE.FileLoader.prototype.load;
THREE.FileLoader.prototype.load = function(url, onLoad, onProgress, onError) {
    if(window.WEBGL_APP_MODE) {

        const requestUrl = this.path? `${this.path}${this.path.endsWith('/') ? '' : '/'}${url}` : url;

        delete this.path;
        
        const payload = {type: 'getData', url: requestUrl};
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        } else {
            window.postMessage({_debug: true, ...payload});
        }

        new Promise((res, rej) => {
            window.CONTENT_VIEWER.requests[requestUrl] = res;
        }).then(dataUri => {
            this._load(dataUri, onLoad, onProgress, onError);
        });
        return;
    }

    this.setRequestHeader({
        'Authorization': `Bearer ${localStorage.getItem('DAStudioAuthToken')}`
    });
    return this._load(url, onLoad, onProgress, onError);
};

THREE.TextureLoader.prototype._load = THREE.TextureLoader.prototype.load;
THREE.TextureLoader.prototype.load = function (url, onLoad, onProgress, onError) {
    if(window.WEBGL_APP_MODE) {

        const payload = {type: 'getData', url};
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        } else {
            window.postMessage({_debug: true, ...payload});
        }

        const texture = new THREE.Texture();

        new Promise((res, rej) => {
            window.CONTENT_VIEWER.requests[url] = res;
        }).then(dataUri => {
            var loader = new THREE.ImageLoader( this.manager );
            loader.setCrossOrigin( this.crossOrigin );
            loader.setPath( this.path );

            loader.load( dataUri, function ( image ) {
                texture.image = image;
    
                // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
                var isJPEG = dataUri.search( /\.jpe?g($|\?)/i ) > 0 || dataUri.search( /^data\:image\/jpeg/ ) === 0;
    
                texture.format = isJPEG ? THREE.RGBFormat : THREE.RGBAFormat;
                texture.needsUpdate = true;
    
                if ( onLoad !== undefined ) {
    
                    onLoad( texture );
    
                }
    
            }, onProgress, onError );
        });


		return texture;

    }

    const token = localStorage.getItem('DAStudioAuthToken');
    if (token) {
        url += `?token=${localStorage.getItem('DAStudioAuthToken')}`;
    }
    // https://github.com/mrdoob/three.js/blob/master/src/loaders/TextureLoader.js
    return this._load(url, onLoad, onProgress, onError);
};

export function checkMobile() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

// first just import it
import "three-ext/controls/OrbitControls.js";
import "three-ext/loaders/ColladaLoader.js";
import "three-ext/loaders/FBXLoader.js";
import "three-ext/loaders/GLTFLoader.js";
import "three-ext/loaders/DRACOLoader.js";
import "three-ext/loaders/LoaderSupport.js";
import "three-ext/loaders/OBJLoader.js";
import "three-ext/loaders/OBJLoader2.js";
import "three-ext/loaders/HDRCubeTextureLoader.js";
import "three-ext/loaders/RGBELoader.js";
import "three-ext/pmrem/PMREMCubeUVPacker.js";
import "three-ext/pmrem/PMREMGenerator.js";
import "three-ext/postprocessing/EffectComposer.js";
import "three-ext/postprocessing/MaskPass.js";
import "three-ext/postprocessing/OutlinePass.js";
import "three-ext/postprocessing/RenderPass.js";
import "three-ext/postprocessing/SSAARenderPass.js";
import "three-ext/postprocessing/SAOPass.js"
import "three-ext/postprocessing/ShaderPass.js";
import "three-ext/postprocessing/TAARenderPass.js";
import "three-ext/postprocessing/UnrealBloomPass.js";
import "three-ext/shaders/ConvolutionShader.js";
import "three-ext/shaders/CopyShader.js";
import "three-ext/shaders/FXAAShader.js";
import "three-ext/shaders/LuminosityHighPassShader.js";
import "three-ext/shaders/SAOShader.js";
import "three-ext/shaders/DepthLimitedBlurShader.js";
import "three-ext/shaders/UnpackDepthRGBAShader.js";
import "three-ext/shaders/BokehShader.js";
import "three-ext/postprocessing/BokehPass.js";
import "three-ext/WebGL.js";

// FIXME var WEBGL from above import ist not accessible from ES6 Imports, no namespace/export -> this is a copy paste!
// TODO Open ISSUE on Github
let DT = {
    isWebGLAvailable: function () {

        try {

            var canvas = document.createElement('canvas');
            return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));

        } catch (e) {

            return false;

        }

    },

    isWebGL2Available: function () {

        try {

            var canvas = document.createElement('canvas');
            return !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));

        } catch (e) {

            return false;

        }

    },

    getWebGLErrorMessage: function () {

        return this.getErrorMessage(1);

    },

    getWebGL2ErrorMessage: function () {

        return this.getErrorMessage(2);

    },

    getErrorMessage: function (version) {

        var names = {
            1: 'WebGL',
            2: 'WebGL 2'
        };

        var contexts = {
            1: window.WebGLRenderingContext,
            2: window.WebGL2RenderingContext
        };

        var message = 'Your $0 does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">$1</a>';

        var element = document.createElement('div');
        element.id = 'webglmessage';
        element.style.fontFamily = 'monospace';
        element.style.fontSize = '13px';
        element.style.fontWeight = 'normal';
        element.style.textAlign = 'center';
        element.style.background = '#fff';
        element.style.color = '#000';
        element.style.padding = '1.5em';
        element.style.width = '400px';
        element.style.margin = '5em auto 0';

        if (contexts[version]) {

            message = message.replace('$0', 'graphics card');

        } else {

            message = message.replace('$0', 'browser');

        }

        message = message.replace('$1', names[version]);

        element.innerHTML = message;

        return element;

    }

};

// Export definition
export let BokehShader = THREE.BokehShader;
export let BokehPass = THREE.BokehPass;
export let ColladaLoader = THREE.ColladaLoader;
export let ConvolutionShader = THREE.ConvolutionShader;
export let CopyShader = THREE.CopyShader;
export let Detector = DT;
export let EffectComposer = THREE.EffectComposer;
export let FBXLoader = THREE.FBXLoader;
export let GLTFLoader = THREE.GLTFLoader;
export let DRACOLoader = THREE.DRACOLoader;
export let FXAAShader = THREE.FXAAShader;
export let HDRCubeTextureLoader = THREE.HDRCubeTextureLoader;
export let LoaderSupport = THREE.LoaderSupport;
export let LuminosityHighPassShader = THREE.LuminosityHighPassShader;
export let MaskPass = THREE.MaskPass;
export let OBJLoader = THREE.OBJLoader;
export let OBJLoader2 = THREE.OBJLoader2;
export let OrbitControls = THREE.OrbitControls;
export let OutlinePass = THREE.OutlinePass;
export let PMREMCubeUVPacker = THREE.PMREMCubeUVPacker;
export let PMREMGenerator = THREE.PMREMGenerator;
export let RenderPass = THREE.RenderPass;
export let RGBELoader = THREE.RGBELoader;
export let SSAARenderPass = THREE.SSAARenderPass;
export let DepthLimitedBlurShader = THREE.DepthLimitedBlurShader;
export let UnpackDepthRGBAShader = THREE.UnpackDepthRGBAShader;
export let SAOShader = THREE.SAOShader;
export let SAOPass = THREE.SAOPass;
export let ShaderPass = THREE.ShaderPass;
export let TAARenderPass = THREE.TAARenderPass;
export let UnrealBloomPass = THREE.UnrealBloomPass;
export * from 'three-declare';


// WEBPACK FOOTER //
// ./src/js/define/three-namespace.js